import {Injectable} from '@angular/core';
import {MyCONST} from '../CONST/myCONST';
import {Socket} from 'ngx-socket-io';
import {UrlService} from './url.service';
import {EnvService} from './env.service';

@Injectable({
  providedIn: 'root'
})
export class SupervisorsocketService {
  supervisor_socket: Socket;
  sim_socket: Socket;
  connected = false;
  sim_connected = false;

  constructor(private url: UrlService, private env: EnvService) {
  }

  supervisor_connect() {
    console.log('supervisor_connect supervisor_connect supervisor_connect ');
    if (!this.env.supervisor_socket_connect) {
      return;
    }
    const url = this.url.socket_url;
    const token = localStorage.getItem(MyCONST.Token);
    this.supervisor_socket = new Socket({
      url: url + 'supervisor?token=' + token, options: {
        transport: ['websocket']
      }
    });
    this.connected = true;
  }

  sim_socket_connect() {
    if (!this.env.sim_socket_connect) {
      return;
    }
    const token = localStorage.getItem(MyCONST.Token);
    const url = this.url.socket_url + 'admin?token=' + token;
    this.sim_socket = new Socket({
      url: url, options: {
        transport: ['websocket']
      }
    });
    this.sim_connected = true;
  }

}
